<template>
  <div class="yCenter">
    <div :style="{ width: getWidth('uploadedDate') }" class="colStyle px-1">
      {{ items.orderDate }}
    </div>
    <div :style="{ width: getWidth('shopName') }" class="colStyle px-1">
      {{ items.shopName }}
    </div>
    <div :style="{ width: getWidth('userId') }" class="colStyle px-1">
      {{ items.user }}
    </div>
    <div :style="{ width: getWidth('exCsvFileNumber') }" class="colStyle px-1">
      {{ items.exCsvFileNumber }}
    </div>
    <div :style="{ width: getWidth('status') }" class="colStyle px-1">
      {{ items.status }}
    </div>

    <NormalButton
      :text="$t('common.common_invalid')"
      class="mr-2"
      btnClass="pa-2"
      width="70px"
      height="32px"
      color="white"
      textColor="thinText--text"
      :outlined="true"
    />
    <NormalButton
      :text="$t('ship.ship_ship-request')"
      class="mr-2"
      btnClass="pa-2"
      width="70px"
      height="32px"
      @click="onClickDeliveryRequest"
    />
    <NormalButton
      :text="$t('sale.sale_sale-register')"
      btnClass="pa-2"
      width="70px"
      height="32px"
      @click="onClickSalesRegistration"
    />

    <ShipRequestDialog v-model="deliveryRequest.dialog" :list="selectedList" />
    <SalesRegistrationDialog
      v-model="salesRegistration.dialog"
      :list="selectedList"
    />
  </div>
</template>

<script>
import NormalButton from '@/components/items/Buttons/NormalButton'
import {
  ShipRequestDialog,
  SalesRegistrationDialog
} from '@/components/layouts/Dialogs/Csv'

export default {
  components: {
    NormalButton,
    ShipRequestDialog,
    SalesRegistrationDialog
  },
  props: {
    headers: { default: [] },
    items: { default: [] }
  },
  data: () => ({
    deliveryRequest: {
      dialog: false
    },
    salesRegistration: {
      dialog: false
    }
  }),
  computed: {
    selectedList() {
      return this.items.productMoves.filter((item) => item.isCheck)
    }
  },
  methods: {
    getWidth(value) {
      const obj = this.headers.find((ele) => ele.value === value)
      return obj ? obj.width : '100px'
    },
    onClickDeliveryRequest() {
      if (this.selectedList.length === 0) {
        return
      }
      this.deliveryRequest.dialog = true
    },
    onClickSalesRegistration() {
      if (this.selectedList.length === 0) {
        return
      }
      this.salesRegistration.dialog = true
    }
  }
}
</script>

<style lang="scss" scoped>
.colStyle {
  word-wrap: break-word;
}
.operationAreaStyle {
  width: 120px;
}
.statusNameStyle {
  width: 36px;
}
</style>
